import { type ReactNode } from 'react';
import { HelpCircle } from 'lucide-react';

interface HelpTooltipProps {
  /** Текст подсказки */
  content: ReactNode;
  /** Размер иконки в пикселях */
  size?: number;
  /** Положение тултипа */
  side?: 'top' | 'bottom' | 'left' | 'right';
  /** Максимальная ширина тултипа */
  maxWidth?: string;
}

const positionClasses: Record<string, string> = {
  top: 'bottom-full left-1/2 -translate-x-1/2 mb-1.5',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-1.5',
  left: 'right-full top-1/2 -translate-y-1/2 mr-1.5',
  right: 'left-full top-1/2 -translate-y-1/2 ml-1.5',
};

export function HelpTooltip({
  content,
  size = 14,
  side = 'top',
  maxWidth = '260px',
}: HelpTooltipProps) {
  return (
    <span className="group relative inline-flex items-center cursor-help">
      <HelpCircle
        className="text-slate-400 hover:text-slate-600 transition-colors"
        style={{ width: size, height: size }}
      />
      <span
        className={`absolute ${positionClasses[side]} px-2.5 py-1.5 bg-slate-800 text-white text-[11px] leading-relaxed rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50`}
        style={{ maxWidth, width: 'max-content' }}
      >
        {content}
      </span>
    </span>
  );
}
